module.exports = __webpack_public_path__ + "img/7.1.3d32a8b3.jpg";